import {getEnvironDomain} from 'utils/urls';

const domain = getEnvironDomain();

export const mainSiteUrl = `//${domain}`;
export const apiUrl = `//${domain}/webapi`;
export const trucksUrl = `//trucks.${domain}`;
export const billingUrl = `//billing.${domain}`;
export const glossaryUrl = `//files.${domain}/glossary`;
export const geoServiceUrlPrefix = `//${domain}/gw/gis-dict/public/v1/geo/`;
export const helpSiteUrl = `//help.${domain}`;
